import i18n from "@/i18n";
import * as validators from "@vuelidate/validators";
import { startOfDay, startOfToday } from "date-fns";

const { createI18nMessage } = validators;
const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) });

export const required = withI18nMessage(validators.required);
export const integer = withI18nMessage(validators.integer);
export const email = withI18nMessage(validators.email);
export const numeric = withI18nMessage(validators.numeric);

export const outwardDateRequired = (outwardDate?: Date) => {
    return !!outwardDate && outwardDate >= startOfToday();
};

export const returnDateRequired = (isReturn: boolean, returnDate?: Date, outwardDate?: Date) => {
    return !isReturn || (!!returnDate && startOfDay(returnDate) >= startOfDay(outwardDate ?? new Date()));
};
